import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { saveAs } from 'file-saver';

import { PageableTableComponent } from '../../shared/controls/pageable-table/pageable-table.component';

import { DialogService } from '../../shared/controls/message-dialog/message-dialog.service';
import { ToastService } from '../../shared/toast/toast.service';
import { InitializerService } from '../../shared/services/initializer-service';
import { ErrorService } from '../../shared/services/error-service';
import { AuthService } from '../../shared/services/auth.service';
import { LoadingService } from '../../shared/services/loading.service';
import { LoadingHelper } from '../../shared/services/loading-helper';

import { HasPermissionDirective } from '../../shared/directives/has-permission.directive';
import { AreaConstants } from '../../shared/constants/area.constants';
import { PermissionConstants } from '../../shared/constants/permission.constants';

import { UserRoleService, DownloadService, FilteredUserRoleItem, PagingData } from '../../../service/proxy';

@Component({
    templateUrl: './user-role.component.html',
    styleUrls: ['./user-role.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
        PageableTableComponent,
        HasPermissionDirective,
    ],

    providers: [
        UserRoleService,
        DownloadService,
    ]
})
export class UserRoleComponent implements OnInit {
    public intialized = false;

    public showEdit: boolean = false;
    public showDelete: boolean = false;

    public search: string = '';
    public paging: PagingData = new PagingData();
    public userRoles: FilteredUserRoleItem[] = [];

    constructor(
        public authService: AuthService,
        private router: Router,
        private userRoleService: UserRoleService,
        private downloadService: DownloadService,
        private dialogService: DialogService,
        private toastService: ToastService,
        private errorService: ErrorService,
        private initializerService: InitializerService,
        private loadingService: LoadingService)
        {
            this.paging = this.initializerService.createPagingData();
        }

    ngOnInit(): void {
        this.initializePermissions();
    }

    initializePermissions(): void {
        this.showEdit = this.authService
            .hasPermission(AreaConstants.Role, PermissionConstants.Edit);

        this.showDelete = this.authService
            .hasPermission(AreaConstants.Role, PermissionConstants.Delete);
    }

    refreshGridData(): void {
        this.paging = this.initializerService.createPagingData();
        this.getUserRoles(this.paging);
    }

    getUserRoles(pagingData: PagingData): void {
        LoadingHelper.withLoading(
            this.userRoleService.getFilteredUserRoles(this.search, pagingData.pageNo, pagingData.pageSize, pagingData.sortDirection, pagingData.sortColumn),
            this.loadingService
        ).subscribe({
            next: (data) => {
                this.paging = data.pagingData;
                this.userRoles = data.results || [];
            },
            error: (error) => {
                if (error.status === 204) {
                    this.userRoles = [];
                    this.paging = this.initializerService.createPagingData();
                }
                else {
                    this.errorService.handleError(error);
                }
            }
        });
    };

    getColumnMap() {
        return {
            description: 'Description',
        };
    }

    upsertUserRole(id: number): void {
        this.router.navigate([`/user-role/${id}`]);
    }

    deleteUserRole(id: number): void {
        this.dialogService.show('Delete', 'Are you sure you want to delete this record?', 'Warning')
            .subscribe((confirmed: boolean) => {
                if (confirmed) {
                    LoadingHelper.withLoading(
                        this.userRoleService.deleteUserRole(id),
                        this.loadingService
                    ).subscribe(() => {
                        this.getUserRoles(this.paging);
                    });
                }
            }
        );
    }

    downloadUserRoles(pagingData: PagingData): void {
        LoadingHelper.withLoading(
            this.downloadService.downloadUserRoles(this.search, pagingData.pageNo, pagingData.pageSize, pagingData.sortDirection, pagingData.sortColumn),
            this.loadingService
        ).subscribe(response => {
            if (response.status === 200) {
                saveAs(response.data, 'User_Roles.xlsx');
            }
            else {
                alert('Download failed');
            }
        });
    }
}
